import { useMemo } from 'react';
import { SUPPORTED_TOKENS } from 'src/utils/constants';
import { timestampToFormattedDate } from 'src/utils/dates';
import { removeTrailingZeros, truncate } from 'src/utils/strings';

const MobileTransactionTable = ({ transactions, accounts }) => {
    const transactionsGroupedByDate = useMemo(() => {
        return transactions.reduce((acc, tx) => {
            if (!tx.time) return acc;
            const time = timestampToFormattedDate(tx.time);
            if (time in acc) {
                return { ...acc, [time]: [...acc[time], tx] };
            }
            return { ...acc, [time]: [tx] };
        }, {});
    }, [transactions]);

    return Object.keys(transactionsGroupedByDate).map((date, i) => (
        <div key={i} className="mb-6">
            <p className="text-center text-base">{date}</p>
            {transactionsGroupedByDate[date].map((tx, j) => {
                const token = tx.tokenSymbol ?? SUPPORTED_TOKENS[tx.network][0];
                const side = tx.from.toLowerCase() === accounts[tx.network].toLowerCase() ? '-' : '+';
                return (
                    <div key={j} className="flex justify-start items-center border-b border-gray-light pb-4 mt-6">
                        <img
                            src={`/crypto-icons/${token}.svg`}
                            alt={`${token} icon`}
                            width={30}
                            className="inline-block mr-2"
                        />
                        <div className="flex flex-col">
                            <span>
                                {side}
                                {removeTrailingZeros(parseFloat(tx.amount).toFixed(8))}
                                &nbsp; &nbsp;
                                {token}
                            </span>
                            <span className="text-gray-darker text-xs">{tx.network} Network</span>
                        </div>
                        <span className="text-xs block ml-auto text-right">
                            {side === '+' ? `from ${truncate(tx.from, 10)}` : `to ${truncate(tx.to, 10)}`}
                        </span>
                    </div>
                );
            })}
        </div>
    ));
};

export default MobileTransactionTable;
